<template>
  <section class="v-cal-content" @scroll="scrollFunction($event)">
    <div class="v-cal-weekdays">
      <div class="v-cal-weekday-item">{{ activeDate.format("ddd DD/MM") }}</div>
    </div>
    <div class="v-cal-days">
      <div class="v-cal-times">
        <div class="v-cal-hour">{{ allDayLabel }}</div>
        <div
          class="v-cal-hour"
          :class="{ 'is-now': time.isSame(now, 'hour') }"
          :key="time"
          v-for="time in times"
        >
          {{ time | formatTime(use12) }}
        </div>
      </div>
      <div class="v-cal-days__wrapper">
        <div
          class="v-cal-day v-cal-day--day"
          :class="{ 'is-today': day.isToday }"
          v-if="day !== null"
        >
          <div
            class="v-cal-day__hour-block"
            @click.stop="timeClicked({ date: day.d.toDate(), time: null })"
          >
            <span class="v-cal-day__hour-block-fill"
              >00:00
              <template v-if="use12"
                >PM</template
              ></span
            >
            <div class="v-cal-day__hour-content">
              <div
                class="v-cal-event-list"
                :class="{
                  'tiny-events': day.events.filter(e => !e.startTime).length > 2
                }"
              >
                <event-item
                  v-for="(event, index) in day.events.filter(e => !e.startTime)"
                  :key="index"
                  :event="event"
                  :use12="use12"
                >
                </event-item>
              </div>
            </div>
          </div>
          <div
            class="v-cal-day__hour-block"
            :class="[
              time.isSame(now, 'hour') ? 'is-now' : '',
              hourClass,
              getClassForHourContainer(
                openCaComponent.clientId,
                time,
                now,
                day.d.toDate(),
              )
            ]"
            :key="time"
            v-for="time in day.availableTimes"
          >
            <div
                v-tooltip="{
              content:!checkCallsForQuarterTool({ time: time, quarterStart: 0, quarterEnd: 15 })?'Hour is out of shift':'',
                }"
              class="quarter-item"
              :class="{...getClassForQuarter(
                  openCaComponent.clientId,
                  time,
                  now,
                  day.d.toDate(),
                  1
                ),
                'hour_is_dis':!checkCallsForQuarter({ time: time, quarterStart: 0, quarterEnd: 15 })
                }
              "
              @click.stop="
              checkCallsForQuarter({ time: time, quarterStart: 0, quarterEnd: 15 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 1,
                getReplaceCallsStats({ time: time, quarterStart: 0, quarterEnd: 15 })
                ):''
              "
            >
              <div class="quarter-title">{{ time.hour() }}-00</div>

              <event-item
                @setNextCallOffset="setNextCallOffset"
                v-for="(event, index) in day.events"
                v-if="setQuarterOrder(event.startTime, time, 0, 15)"
                :key="index"
                :event="event"
                :use12="use12"
                @replaceClientCall="checkCallsForQuarter({ time: time, quarterStart: 0, quarterEnd: 15 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 1,
                getReplaceCallsStats({ time: time, quarterStart: 0, quarterEnd: 15 })
                ):''"

              >
                :time="time"
              </event-item>
              <ScheduledCallsQuarterLog
                :dayCalls="day.events"
                :quarter="{ time: time, quarterStart: 0, quarterEnd: 15 }"
              />
            </div>
            <div
                v-tooltip="{
              content:!checkCallsForQuarterTool({ time: time, quarterStart: 15, quarterEnd: 30 })?'Hour is out of shift':'',
                }"
              class="quarter-item"
              :class="{...getClassForQuarter(
                  openCaComponent.clientId,
                  time,
                  now,
                  day.d.toDate(),
                  2
                ),
                'hour_is_dis':!checkCallsForQuarter({ time: time, quarterStart: 15, quarterEnd: 30 })
            }
              "
              @click.stop="
              checkCallsForQuarter({ time: time, quarterStart: 15, quarterEnd: 30 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 2,
                getReplaceCallsStats({ time: time, quarterStart: 15, quarterEnd: 30 })):''
              "
            >
              <div class="quarter-title">{{ time.hour() }}-15</div>

              <event-item
                @setNextCallOffset="setNextCallOffset"
                v-for="(event, index) in day.events"
                v-if="setQuarterOrder(event.startTime, time, 15, 30)"
                :key="index"
                :event="event"
                :use12="use12"
                @replaceClientCall="checkCallsForQuarter({ time: time, quarterStart: 15, quarterEnd: 30 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 2,
                getReplaceCallsStats({ time: time, quarterStart: 15, quarterEnd: 30 })
                ):''"
              >
                :time="time"
              </event-item>
              <ScheduledCallsQuarterLog
                :dayCalls="day.events"
                :quarter="{ time: time, quarterStart: 15, quarterEnd: 30 }"
              />
            </div>
            <div
                v-tooltip="{
              content:!checkCallsForQuarterTool({ time: time, quarterStart: 30, quarterEnd: 45 })?'Hour is out of shift':'',
                }"
              class="quarter-item"
              :class="{...getClassForQuarter(
                  openCaComponent.clientId,
                  time,
                  now,
                  day.d.toDate(),
                  3
                ),
                'hour_is_dis':!checkCallsForQuarter({ time: time, quarterStart: 30, quarterEnd: 45 })
                }
              "
              @click.stop="
              checkCallsForQuarter({ time: time, quarterStart: 30, quarterEnd: 45 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 3,
                getReplaceCallsStats({ time: time, quarterStart: 30, quarterEnd: 45 })):''
              "
            >
              <div class="quarter-title">{{ time.hour() }}-30</div>

              <event-item
                @setNextCallOffset="setNextCallOffset"
                v-for="(event, index) in day.events"
                v-if="setQuarterOrder(event.startTime, time, 30, 45)"
                :key="index"
                :event="event"
                :use12="use12"
                @replaceClientCall="checkCallsForQuarter({ time: time, quarterStart: 30, quarterEnd: 45 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 3,
                getReplaceCallsStats({ time: time, quarterStart: 30, quarterEnd: 45 })
                ):''"
              >
                :time="time"
              </event-item>
              <ScheduledCallsQuarterLog
                :dayCalls="day.events"
                :quarter="{ time: time, quarterStart: 30, quarterEnd: 45 }"
              />
            </div>
            <div
                v-tooltip="{
              content:!checkCallsForQuarterTool({ time: time, quarterStart: 45, quarterEnd: 60 })?'Hour is out of shift':'',
                }"
              class="quarter-item"
              :class="{...getClassForQuarter(
                  openCaComponent.clientId,
                  time,
                  now,
                  day.d.toDate(),
                  4
                ),
                'hour_is_dis':!checkCallsForQuarter({ time: time, quarterStart: 45, quarterEnd: 60 })
            }"

              @click.stop="
              checkCallsForQuarter({ time: time, quarterStart: 45, quarterEnd: 60 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 4,
                getReplaceCallsStats({ time: time, quarterStart: 45, quarterEnd: 60 })):''
              "
            >
              <div class="quarter-title">{{ time.hour() }}-45</div>

              <event-item
                @setNextCallOffset="setNextCallOffset"
                v-for="(event, index) in day.events"
                v-if="setQuarterOrder(event.startTime, time, 45, 60)"
                :key="index"
                :event="event"
                :use12="use12"
                @replaceClientCall="checkCallsForQuarter({ time: time, quarterStart: 45, quarterEnd: 60 })?
                timeClicked({ date: day.d.toDate(), time: time.hour() }, 4,
                getReplaceCallsStats({ time: time, quarterStart: 45, quarterEnd: 60 })
                ):''"
              >
                :time="time"
              </event-item>
              <ScheduledCallsQuarterLog
                :dayCalls="day.events"
                :quarter="{ time: time, quarterStart: 45, quarterEnd: 60 }"
              />
            </div>
            <span class="v-cal-day__hour-block-fill">{{
              time | formatTime(use12)
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import { EventBus } from "../EventBus";
import EventItem from "../EventItem";
import IsView from "../mixins/IsView";
import ShowsTimes from "../mixins/ShowsTimes";
import { mapState } from "vuex";
import ScheduledCallsQuarterLog from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/ScheduledCallsPopUp/ScheduledCallsQuarterLog.component";
import UsersPermissionCheck from "../../../../../../../../../../mixins/user/auth/UsersPermissionCheck";


export default {
  name: "day",
  mixins: [IsView, ShowsTimes,UsersPermissionCheck],
  components: { ScheduledCallsQuarterLog, EventItem },
  props:{
    newCall:{
      type: Object
    }
  },
  data() {
    return {
      day: null,
      currentHour: null,
      offsetOfNextCall: 0
    };
  },
  computed: {
    ...mapState("clients", ["openCaComponent", "dictionaries"])
  },
  mounted() {
    this.buildCalendar();
    this.scrollToCurrentHour();
    if (this.day.isToday) {
      this.disablePassedHours(document.getElementsByClassName("v-cal-hour"));
    }


    // this.getCurrentHour(this.day)
  },
  methods: {
    scrollFunction(event){
      let element = 0
      element = $('.v-cal-content').scrollTop();
      EventBus.$emit('setScrollLoading',element)
    },
    handleScroll(){
    },
    getClassForHourContainer(clientId, time, now, selectedDay) {
      if (clientId !== null) {
        if (moment(selectedDay).isAfter(now, "day")) {
          return " ";
        } else {
          if (time.isBefore(now, "hour")) {
            return "is-in-past";
          }
        }
      }
    },
    getClassForQuarter(clientId, time, now, selectedDay, quarter) {
      if (clientId !== null) {

        if (moment(selectedDay).isAfter(now, "day")) {
          return {" ":true};
        } else {
          if (time.isBefore(now, "hour")) {
            return {"is-in-past":true};
          } else if (time.isSame(now, "hour")) {
            let quarterByNowMinutes = 1;
            if (now.minute() < 31) {
              quarterByNowMinutes = 2;
            } else if (now.minute() < 46) {
              quarterByNowMinutes = 3;
            } else if (now.minute() < 60) {
              quarterByNowMinutes = 4;
            }
            if (quarterByNowMinutes > quarter) {
              return {"quarter-is-in-past":true};
            }
          }
        }
      }
    },
    setQuarterOrder(startTime, time, quarterMinutesStart, quarterMinutesEnd) {
      if (startTime && time.hours() === startTime.hours()) {
        if (
          startTime.minutes() >= quarterMinutesStart &&
          startTime.minutes() < quarterMinutesEnd
        ) {
          return true;
        }
      }
    },
    setNextCallOffset(value) {
      // Function gets Number and scrolls opened popup to next future call
      this.offsetOfNextCall = value;


      // if(this.openCaComponent.clientId){
      //   if ($(".new")[0] === undefined) {
      //     $(".v-cal-content").animate(
      //         { scrollTop: this.offsetOfNextCall - 250 },
      //         "fast"
      //     );
      //   }
      // }




    },
    // isComingCallClass(events){
    //   // if(event.startTime > moment()){
    //   //   return true
    //   // } else{
    //   //   return false
    //   // }
    //   return true
    // },
    // getCurrentHour(day){
    //   day.availableTimes.forEach(item=>{
    //   })
    //
    // },
    getEventItems(event, time, quarter) {
      switch (quarter) {
        case 1:
          if (event.startTime && time.hours() === event.startTime.hours()) {
            if (0 <= event.startTime.minutes() <= 15) {
              return true;
            }
          }
          break;
        case 2:
          if (event.startTime && time.hours() === event.startTime.hours()) {
            if (16 <= event.startTime.minutes() <= 30) {
              return true;
            }
          }
          break;
        case 3:
          if (event.startTime && time.hours() === event.startTime.hours()) {
            if (31 <= event.startTime.minutes() <= 45) {
              return true;
            }
          }
          break;
        case 4:
          if (event.startTime && time.hours() === event.startTime.hours()) {
            if (46 <= event.startTime.minutes() <= 59) {
              return true;
            }
          }
          break;
      }
      // if(event.startTime && time.hours() === event.startTime.hours()){
      //   return true
      // }
    },
    scrollToCurrentHour() {
      if (this.openCaComponent.clientId !== null) {
        $(".v-cal-content").animate(
          { scrollTop: $(".is-now").offset().top - 250 },
          "fast"
        );
      } else {
        if(this.offsetOfNextCall == 0){

        }
        $(".v-cal-content").animate(
          { scrollTop: this.offsetOfNextCall - 250 },
          "fast"
        );
      }

      // $(".v-cal-content").animate({ scrollTop: 9999 }, "fast");
    },
    getQuarterOfAnHour(e) {
      let rect = e.target.getBoundingClientRect();
      // let x = e.clientX - rect.left; //x position within the element.
      let y = e.clientY - rect.top; //y position within the element.
      if (y >= 0 && y <= 25) {
        return 1;
      } else if (y >= 26 && y <= 50) {
        return 2;
      } else if (y >= 51 && y <= 75) {
        return 3;
      } else if (y >= 76 && y <= 100) {
        return 4;
      } else {
        return 1;
      }
    },
    timeClicked(data, quarter,oldArr) {
      data.quarter = quarter;
      data.replaceClients = oldArr;
      EventBus.$emit("time-clicked", data);
    },
    // timeClicked(data, e) {
    //   let quarter = this.getQuarterOfAnHour(e)
    //   data.quarter = quarter
    //   EventBus.$emit("time-clicked", data);
    // },
    disablePassedHours(hours, hourBlocks) {
      hours.forEach(item => {
        if (moment(parseInt(item.innerHTML, "HH:mm")) < moment().format("HH")) {
          item.classList.add("passed-hour", "v-cal-hour");
        }
      });
    },
    buildCalendar() {
      let now = moment();

      const today = moment(this.activeDate);
      const dayEvents = this.events
        .filter(e => moment(e.date).isSame(today, "day"))
        .sort((a, b) => {
          if (!a.startTime) return -1;
          if (!b.startTime) return 1;
          return (
            moment(a.startTime, "HH:mm").format("HH") -
            moment(b.startTime, "HH:mm").format("HH")
          );
        });
      const mappedEvents = dayEvents.map(event => {
        event.overlaps = dayEvents.filter(
          e =>
            moment(event.startTime, "HH:mm").isBetween(
              moment(e.startTime, "HH:mm"),
              moment(e.endTime, "HH:mm")
            ) && e !== event
        ).length;
        return event;
      });

      this.day = {
        d: today,
        isPast: today.isBefore(now, "day"),
        isToday: today.isSame(now, "day"),
        availableTimes: this.times,
        events: mappedEvents
      };
    },
    checkCallsForQuarter(quarter){
      // if(!this.CheckUserPermission([7])){
      //   return true;
      // }
      if(this.shift.length > 0){
        let hour = parseInt(moment(quarter.time).format('H'));
         let fDate = moment(quarter.time).format('YYYY-MM-DD');

         let start = this.shift[0].choice_day_number == 6?this.shift[0].shift_info.friday_start : this.shift[0].shift_info.start;
         let end = this.shift[0].choice_day_number == 6?this.shift[0].shift_info.friday_finish : this.shift[0].shift_info.finish;

        let dateShiftEnd = parseInt(moment(fDate + ' ' + end).format('H'));
        let dateShiftStart = parseInt(moment(fDate + ' ' + start).format('H'));

        if(hour < dateShiftStart || hour >= dateShiftEnd){

          return false
        }

      }
      else{
        let hour = parseInt(moment(quarter.time).format('H'));
        if(hour < 9 || hour >= 23){
          return false
        }
      }

      let tempArr = [];
      let calls = this.day.events;
      // calls.forEach(call => {
      //   if (
      //       this.setQuarterOrder(
      //           call.startTime,
      //           quarter.time,
      //           quarter.quarterStart,
      //           quarter.quarterEnd
      //       ) &&
      //       call.user &&
      //       call.user.id &&
      //       call.user.id === this.auth.user.id
      //   ) {
      //     tempArr.push(call);
      //   }
      // });

      return !tempArr.length > 0
    },
    checkCallsForQuarterTool(quarter){
      // if(!this.CheckUserPermission([7])){
      //   return true;
      // }
      if(this.shift.length > 0){
        let hour = parseInt(moment(quarter.time).format('H'));
         let fDate = moment(quarter.time).format('YYYY-MM-DD');

        let dateShiftEnd = parseInt(moment(fDate + ' ' + this.shift[0].shift_info.finish).format('H'));
        let dateShiftStart = parseInt(moment(fDate + ' ' + this.shift[0].shift_info.start).format('H'));

        if(hour < dateShiftStart || hour >= dateShiftEnd){

          return false
        }

      }
      else{
        let hour = parseInt(moment(quarter.time).format('H'));
        if(hour < 9 || hour >= 23){
          return false
        }
      }

      return true
    },
    getReplaceCallsStats(quarter){
      let tempArr = [];
      let calls = this.day.events;
      calls.forEach(call => {
        if (
            this.setQuarterOrder(
                call.startTime,
                quarter.time,
                quarter.quarterStart,
                quarter.quarterEnd
            ) &&
            call.user &&
            call.user.id &&
            call.user.id === this.auth.user.id
        ) {
          tempArr.push(call.clientId);
        }
      });
      return tempArr
    },
  },
  watch:{
    offsetOfNextCall(){
      //this.scrollToCurrentHour();
    },
    newCall(){
      // console.log(this.newCall.startTime.slice(0,2))
      // // console.log($('.v-cal-day__hour-block'))
      // let x = $('.v-cal-day__hour-block')[this.newCall.startTime.slice(0,2)]
      // console.log(x.scrollTop())
      // console.log(document.getElementsByClassName('new-event-cancel-button-wrapper')[0].offset())
      // console.log($('.new').prevObject[0].offset())
      // $(".v-cal-content").animate(
      //     { scrollTop: $(".new").offset().top - 250 },
      //     "fast"
      // );

    }
  }

};
</script>

<style scoped>
.hour_is_dis{
  background-color: #9ac3dd;
  color: #dfe2e7;
  opacity: 0.7;
  cursor: not-allowed;
}
.passed-hour {
  cursor: default;
  background-color: #d3caca;
  pointer-events: none;
  opacity: 0.8;
}
.quarter-wrapper {
  display: flex;
  flex-direction: column;
}
.hours-quarter {
  height: 25%;
  border-bottom: 1px solid lightgrey;
  text-align: left;
}
.hours-quarter:hover {
  background-color: lightgrey;
}
.v-cal-day__hour-block {
  padding: 0px !important;
}
.v-cal-event-list {
  height: 100%;
}
.containerbackground {
  width: 100%;
  display: flex;
  height: 100%;
  /* margin: 3rem; */
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*bottom: 0;*/
  /*z-index: 1;*/
  /* transform: rotate(300deg); */
  /* -webkit-transform: rotate(300deg); */
  color: #c6afaf;
  flex-direction: column;
}
.containerbackground div {
  flex: 1;
  border-bottom: 1px solid;
  text-align: left;
}
/*.containerbackground + div:hover {*/
/*  background-color: #dcd5d5;*/
/*  color: white;*/
/*}*/
.v-cal-content.v-cal-content--week
  .v-cal-days
  .v-cal-days__wrapper
  .v-cal-event-item,
.v-cal-content.v-cal-content--day
  .v-cal-days
  .v-cal-days__wrapper
  .v-cal-event-item {
  /*z-index: 2 !important;*/
}
.is-in-past div {
  /*color: red;*/
  pointer-events: none;
  background-color: #d5cdcd;
  opacity: 0.8;
  cursor: default;
}
div:has(div.is-in-past) {
  cursor: default;
}
.quarter-to-view-only div {
  background-color: inherit;
  color: inherit;
  cursor: default;
  border-bottom: 1px solid lightgrey;
}
.quarter-to-view-only div:hover {
  background-color: inherit;
  color: inherit;
  cursor: default;
}
.quarter-item {
  /*z-index: 10;*/
  height: 25%;
  /* z-index: 10; */
  border-bottom: 1px solid lightgray;
  display: flex;
  cursor: pointer !important;
}
.quarter-item:hover {
  background-color: #dcd5d5 !important;
  color: white !important;
  /*z-index: 1;*/
}
.quarter-title {
  text-align: left;
  white-space: nowrap;
  width: 40px;
}
.quarter-is-in-past {
  opacity: 0.8;
  cursor: default;
  pointer-events: none;
  background-color: #dbd5d6;
}
</style>
